import React from 'react';
import {Provider} from  'react-redux'
import {createStore} from '../../redux/utils'
import {MODAL_POPUP_ID} from '../../redux/const'
import './App.css';

import ModalPopup from '../ModalPopup'
import ResultTable from '../ResultTable'

import SignUpForm from '../SignUpForm'
import UserLoginForm from '../UserLoginForm'
import AddDomainResourceForm from '../AddDomainResourceForm'
import AddDomainForm from '../AddDomainForm'
import ConfirmationForm from '../ConfirmationForm'
import AccountManagementForm from '../AccountManagementForm'

import LandingPage from '../../pages/LandingPage'
import LandingPageContent from '../../content/LandingPageContent'

import HeaderComponent from '../HeaderComponent'

const App = () => {
	const store = createStore()

	return (
		<Provider store={store}>
			<div className="App">
				<ModalPopup id={MODAL_POPUP_ID.LOGIN} width="80%">
					<UserLoginForm/>
				</ModalPopup>
				<ModalPopup id={MODAL_POPUP_ID.SIGN_UP} width="80%">
					<SignUpForm/>
				</ModalPopup>
				<ModalPopup id={MODAL_POPUP_ID.CONFIRM_ACCOUNT} width="80%">
					<ConfirmationForm/>
				</ModalPopup>
				<ModalPopup id={MODAL_POPUP_ID.ADD_DOMAIN} width="80%">
					<AddDomainForm/> 
				</ModalPopup>
				<ModalPopup id={MODAL_POPUP_ID.ADD_DOMAIN_RESOURCE} width="80%">
					<AddDomainResourceForm/>
				</ModalPopup>
                <ModalPopup id={MODAL_POPUP_ID.ACCOUNT_MANAGEMENT} width="80%">
                    <AccountManagementForm/>
                </ModalPopup>
				
				<HeaderComponent/>

				<LandingPage content={LandingPageContent}/>
				
				<ResultTable/>
			</div>
		</Provider>
	)
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js